import { Mic, MicOff } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { accordDonne, demarrerDictee, dicteeDisponible, memoriserAccord, MESSAGE_ACCORD, MESSAGES_ERREUR_DICTEE, type SessionDictee } from '../lib/dictee'
import { Bouton } from './composants/bouton'

/**
 * Bouton micro : dicte du texte au chantier. N'apparaît pas si le navigateur ne sait pas faire (Firefox). Le texte
 * dicté est remis à `ajouter` phrase par phrase ; l'écoute s'arrête au second appui ou toute seule après un silence.
 */
export function BoutonDictee({ ajouter, libelle = 'Dicter' }: { ajouter: (texte: string) => void; libelle?: string }) {
  const [ecoute, setEcoute] = useState(false)
  const [erreur, setErreur] = useState<string | null>(null)
  const session = useRef<SessionDictee | null>(null)
  useEffect(() => () => session.current?.arreter(), [])
  if (!dicteeDisponible()) return null

  function basculer() {
    if (ecoute) return session.current?.arreter()
    if (!accordDonne()) {
      if (!confirm(MESSAGE_ACCORD)) return
      memoriserAccord()
    }
    setErreur(null)
    session.current = demarrerDictee({
      surPhrase: ajouter,
      surFin: (e) => {
        setEcoute(false)
        if (e) setErreur(MESSAGES_ERREUR_DICTEE[e] ?? `La dictée s’est arrêtée (${e}).`)
      },
    })
    setEcoute(!!session.current)
  }

  return (
    <span className="flex flex-col gap-1">
      <Bouton type="button" variante={ecoute ? 'principal' : 'secondaire'} className="min-h-12 self-start px-3" onClick={basculer} aria-pressed={ecoute} aria-label={ecoute ? 'Arrêter la dictée' : libelle}>
        {ecoute ? <MicOff aria-hidden /> : <Mic aria-hidden />}
        {ecoute ? 'Écoute… (toucher pour arrêter)' : libelle}
      </Bouton>
      {erreur && (
        <span className="text-sm text-red-800" role="alert">
          {erreur}
        </span>
      )}
    </span>
  )
}
